import { render, staticRenderFns } from "./WaitingReview.vue?vue&type=template&id=a9637a46&scoped=true&lang=pug"
import script from "./WaitingReview.vue?vue&type=script&lang=js"
export * from "./WaitingReview.vue?vue&type=script&lang=js"
import style0 from "./WaitingReview.vue?vue&type=style&index=0&id=a9637a46&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9637a46",
  null
  
)

export default component.exports